import React from 'react';

/**
 * Contexts
 */
import { useContext, useEffect } from 'react';
import { AppContext } from '../../contexts/AppContext';

/**
 * Hooks
 */
import useUserWorks from '../../hooks/User/useUserWorks';
import { useTranslation } from 'react-i18next';
import { useAppMenu } from '../../contexts/NavBarContext';

/**
 * MUI Components
 */
import { Box } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

/**
 * Components
 */
import ListWorks from '../../components/Work/ListWorks';

const MyWorks = () => {
    const { t } = useTranslation();
    const appData = useContext(AppContext);
    const { UserWorks, loading: userWorksLoading, error: userWorksError } = useUserWorks(appData.userInfo?.id, appData.token);
    const { updateTitle } = useAppMenu();

    useEffect(() => {
        const pageTitle = t('myWorks');
        updateTitle(pageTitle);
    }, [t, updateTitle]);

    if (userWorksLoading) {
        return (
            <div>
                {t('loading')}...
                <CircularProgress />
            </div>
        );
    }

    if (userWorksError) {
        return <div>{t('error')}: {userWorksError?.message}</div>;
    }

    return (
        <Box sx={{ p: 2, paddingBottom: '72px' }} >
            <ListWorks items={UserWorks} />
        </Box>
    );
};

export default MyWorks;